import { useEffect, useReducer, useState, useRef } from 'react';
import { useParams, useSearchParams, useLocation } from 'react-router-dom';

import axios from 'axios';
import { getReducer } from '../../../utils';

import Breadcrumb from '../../layouts/Breadcrumb';
import './css/postLayout.css';
import PostDetail from './compoments/PostDetail';
import RightSidebar from './compoments/RightSidebar';
import EnrollmentForm from '../enrollment/EnrollmentForm';
import LoadingBox from '../../compoment/LoadingBox';
import MessageBox from '../../compoment/MessageBox';
import PostList from './compoments/PostList';
import Pagination from '../../compoment/Pagination';
import Comments from './compoments/Comments';
import PostListHelmet from '../../../helmet/UsePostListHelmet';

const reducer = (state, action) => {
  switch (action.type) {
    case 'FETCH_REQUEST':
      return { ...state, loading: true };
    case 'FETCH_SUCCESS_POST':
      return { ...state, post: action.payload, loading: false };
    case 'FETCH_SUCCESS_TOPIC_POST':
      const safePayload = action.payload?.posts
        ? action.payload
        : { posts: [] };
      return { ...state, topicPost: safePayload, loading: false };

    case 'FETCH_SUCCESS_RELATED':
      return { ...state, relatedPosts: action.payload, loading: false };
    case 'FETCH_FAIL':
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

const PostScreen = () => {
  const [{ loading, error, post, topicPost, relatedPosts }, dispatch] =
    useReducer(getReducer(reducer), {
      post: null,
      topicPost: [],
      relatedPosts: [],
      loading: true,
      error: '',
    });

  const params = useParams();
  const { slug = null, title = null } = params;

  const cleanKeyword = (str) => str.trim().replace(/\s+/g, ' ');

  const [searchParams] = useSearchParams();
  let keyword = cleanKeyword(searchParams.get('keyword') || '');

  const [breadcrumb, setBreadcrumb] = useState({
    title: '',
    slug: '',
  });

  const [pageIndex, setPageIndex] = useState(1);
  const MAX_LIMIT = 10;

  useEffect(() => {
    const fetchData = async () => {
      dispatch({ type: 'FETCH_REQUEST' });
      try {
        const resultPost = await axios.get(`/post/show/${slug}`);
        dispatch({ type: 'FETCH_SUCCESS_POST', payload: resultPost.data.data });

        const resultPosts = await axios.get(
          title === 'tim-kiem'
            ? `/post/public/shows?keyword=${keyword}&page=${pageIndex}&limit=${MAX_LIMIT}`
            : `/post/public/shows?topicSlug=${title}&page=${pageIndex}&limit=${MAX_LIMIT}`
        );

        dispatch({
          type: 'FETCH_SUCCESS_TOPIC_POST',
          payload: resultPosts.data.data,
        });

        const resultTopic = await axios.get('/topic/public/shows');
        const topic = resultTopic.data.data.topics.find(
          (topic) => topic.slug === title
        );
        if (topic) {
          setBreadcrumb({ title: topic.name, slug: topic.slug });
        }

        const topicPosts = resultPosts?.data?.data?.posts ?? [];
        const currentSlug = resultPost?.data?.data?.slug ?? '';

        const related =
          topicPosts.length > 0 && currentSlug
            ? topicPosts.filter((p) => p.slug !== currentSlug).slice(0, 3)
            : topicPosts.slice(0, 3);

        dispatch({ type: 'FETCH_SUCCESS_RELATED', payload: related });
      } catch (err) {
        dispatch({ type: 'FETCH_FAIL', payload: err.message });
      }
    };
    fetchData();
  }, [slug, keyword, title, pageIndex, MAX_LIMIT]);

  const commentsRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollToComments && commentsRef.current) {
      commentsRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location]);

  const topicForSEO = topicPost?.posts?.[0]?.topics?.[0] ||
    (breadcrumb?.name
      ? { slug: breadcrumb?.slug, name: breadcrumb?.name }
      : null) || { slug: 'khong-co', name: 'Bài viết' };

  // console.log('[topicForSEO]', topicForSEO);

  return loading ? (
    <LoadingBox />
  ) : error ? (
    <MessageBox variant="danger"> {error} </MessageBox>
  ) : (
    <div>
      <Breadcrumb />
      <section className="post-layout">
        <div className="container">
          <div className="row">
            <div className="col-lg-9 col-md-9 col-12">
              {slug && post && (
                <div>
                  <PostDetail data={post} slug={slug} breadcrumb={breadcrumb} />
                  <div ref={commentsRef} id="comments">
                    <Comments ableId={post ? post.id : ''} />
                  </div>
                </div>
              )}

              {!slug && topicPost?.posts?.length > 0 && (
                <>
                  <PostListHelmet topic={topicForSEO} />
                  <PostList topic={breadcrumb} data={topicPost.posts} />
                </>
              )}

              {!slug && (!topicPost?.posts || topicPost.posts.length === 0) && (
                <>
                  <PostListHelmet topic={topicForSEO} />
                  <div className="bg-white shadow-lg mb-3 no-post">
                    <p>Không có dữ liệu bài viết.</p>
                  </div>
                </>
              )}
            </div>

            <div className="col-lg-3 col-md-3 col-12">
              <RightSidebar title={title} relatedPosts={relatedPosts} />
            </div>
          </div>

          {!slug && (
            <Pagination
              onTop={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              setPage={setPageIndex}
              totalPages={topicPost.totalPages}
              currentPage={topicPost.currentPage}
            />
          )}
        </div>
        <EnrollmentForm />
      </section>
    </div>
  );
};

export default PostScreen;
